import React from 'react';
import { Quote, Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  city: string;
  quote: string;
  age: number;
}
export function TestimonialCard({
  name,
  role,
  city,
  quote,
  age
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full hover:shadow-lg transition-shadow duration-300" data-id="element-294">
      <div className="flex gap-1 mb-4" data-id="element-295">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-296" />)}
      </div>

      <Quote className="w-8 h-8 text-emerald-100 mb-2" data-id="element-297" />

      <p className="text-gray-700 italic mb-6 flex-grow leading-relaxed" data-id="element-298">
        "{quote}"
      </p>

      <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-299">
        <p className="font-bold text-gray-900" data-id="element-300">
          {name}, {age}
        </p>
        <p className="text-sm text-emerald-700 font-medium" data-id="element-301">{role}</p>
        <p className="text-xs text-gray-500" data-id="element-302">{city}</p>
      </div>
    </div>;
}